(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) : typeof define === 'function' && define.amd ? define(['exports'], factory) : factory(global.AF = {});
})(this, function (exports) {
  'use strict';

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var inst = null;

  function af() {
    if (!inst) inst = new AF();
    return inst;
  }

  var AF = function () {
    function AF() {
      _classCallCheck(this, AF);

      this._frame = null;
      this._stopped = true;
      this._oneRead = [];
      this._oneWrite = [];
      this._read = [];
      this._write = [];
      this._animate = this._animate.bind(this);
      if (typeof window !== 'undefined') this.start();
    }

    _createClass(AF, [{
      key: 'start',
      value: function start() {
        if (!this._stopped) return;
        this._stopped = false;

        this._animate();
      }
    }, {
      key: 'stop',
      value: function stop() {
        if (this._stopped) return;
        this._stopped = true;
        window.cancelAnimationFrame(this._frame);
      }
    }, {
      key: '_animate',
      value: function _animate() {
        var oW = this._oneWrite,
            oR = this._oneRead,
            r = this._read,
            w = this._write;
        var i = void 0; // do one read, remove and trigger; then trigger loop reads

        while (oR.length) {
          oR.shift()();
        }

        for (i = 0; i < r.length; i++) {
          r[i]();
        } // do one write, remove and trigger; then trigger loop writes


        while (oW.length) {
          oW.shift()();
        }

        for (i = 0; i < w.length; i++) {
          w[i]();
        }

        this._frame = window.requestAnimationFrame(this._animate);
      }
    }, {
      key: 'onNextRead',
      value: function onNextRead(fn) {
        this._oneRead.push(fn);
      }
    }, {
      key: 'onNextWrite',
      value: function onNextWrite(fn) {
        this._oneWrite.push(fn);
      }
    }, {
      key: 'addRead',
      value: function addRead(fn) {
        this._read.push(fn);
      }
    }, {
      key: 'addWrite',
      value: function addWrite(fn) {
        this._write.push(fn);
      }
    }, {
      key: 'removeRead',
      value: function removeRead(fn) {
        var r = this._read,
            l = r.length;

        for (var i = 0; i < l; i++) {
          if (r[i] === fn) r.splice(i, 1);
        }
      }
    }, {
      key: 'removeWrite',
      value: function removeWrite(fn) {
        var w = this._write,
            l = w.length;

        for (var i = 0; i < l; i++) {
          if (w[i] === fn) w.splice(i, 1);
        }
      }
    }]);

    return AF;
  }();

  exports.AF = AF;
  exports.af = af;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});